import { httpClient } from '@/lib/http/HttpClient'
import { Country } from '@/models/app'
import { CartDetailResponse } from '@/models/cart'
import { PAY_QUERY_PARAM_NAME } from './constants'

export async function openReservationSummary(payload: {
  cartDetail: CartDetailResponse
  country: Country
  lang: string
  licenseCode: string
  searchParams: URLSearchParams
  target: '_blank' | '_self'
}) {
  const payParam = payload.searchParams.get(PAY_QUERY_PARAM_NAME)

  const queryParams = new URLSearchParams()

  if (payParam) {
    queryParams.set(PAY_QUERY_PARAM_NAME, payParam)
  }

  const reservationIds = payload.cartDetail.cart.reservationModels.map(
    (reservation) => reservation.id
  )
  queryParams.set('lang', payload.lang)

  const responses = await Promise.all(
    reservationIds.map((reservationId) =>
      httpClient.fetch<string>(
        `beaches/${payload.licenseCode}/reservations/${reservationId}?${queryParams.toString()}`,
        payload.country,
        {
          headers: {
            Accept: 'text/html',
          },
        },
        true
      )
    )
  )
  const spaceHtml = `<html><body><div style="padding-bottom: 80px; background-color: #EFEFF0"></div></body></html>`

  const blobParts: BlobPart[] = [
    spaceHtml,
    ...responses.flatMap((response, index, array) => {
      if (response.status === 'error') return ''

      return index < array.length - 1
        ? [response.data, spaceHtml]
        : response.data
    }),
    spaceHtml,
  ]

  // all the blob parts are combined in a single html file that includes
  // all the content in a single body element
  const blob = new Blob(blobParts, { type: 'text/html' })
  const url = URL.createObjectURL(blob)
  window.open(url, payload.target)
}
